var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"groupFields",class:[_vm.customClass, {'right': _vm.isRight, 'center': _vm.isCenter}],style:({ alignItems: _vm.alignItems, justifyContent: _vm.justifyContent, flex: _vm.flex, width: _vm.width, margin: _vm.margin })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }